/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rights_Drawer_Removes_Override_HintInputs */



/**
* | output |
* | --- |
* | "Selecting this removes the subject's override." |
*
* @param {Rights_Drawer_Removes_Override_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_drawer_removes_override_hint = /** @type {((inputs?: Rights_Drawer_Removes_Override_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Drawer_Removes_Override_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Diese Auswahl entfernt die Ausnahme des Subjekts.")
	return /** @type {LocalizedString} */ ("Selecting this removes the subject's override.")
});